
export {Popover} from '@clayui/popover';
import __x__ from '@clayui/popover';export default __x__;